export default __webpack_public_path__ + "static/button-label-do-aa94068e550e646c3703a21c0f9b291421add539346a864d80de91fcc5a6a287.png";